export const BATCH = 'batch';
export const BUNDLE = 'bundle';
export const INVENTORY = 'inventory';
export const SERIALIZED = 'serialized';
export const MATRIX = 'matrix';

export const SERVICE = 'service';
export const NONINVENTORY = 'noninventory';
export const SHIPPING = 'shipping';
export const GIFTCERTIFICATE = 'giftcertificate';
export const COUPON = 'coupon';

export const LOYALTY = 'loyalty';
export const DISCOUNT = 'discount';
export const PROMOTION = 'promotion';

export const PAYMENT_SURCHARGE = 'payment_surcharge';
export const SERVICE_CHARGE = 'service_charge';
export const GRATUITY = 'gratuity';

export const INVENTORY_ITEM_TYPES = [INVENTORY, BUNDLE, SERIALIZED, BATCH];
export const NO_PRICE_BOOK_ITEM_TYPES = [
  DISCOUNT,
  COUPON,
  PROMOTION,
  PAYMENT_SURCHARGE,
  SERVICE_CHARGE,
  GRATUITY,
];
